<template>
    <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 471.04 471.04" style="enable-background:new 0 0 471.04 471.04;" xml:space="preserve">
        <g>
            <g>
                <path fill="currentColor" d="M414.72,112.64h-48.947l-27.341-40.96c-10.472-15.456-27.922-24.718-46.592-24.73H179.2
                    c-18.669,0.011-36.12,9.273-46.592,24.73l-27.29,40.96H56.32C25.215,112.64,0,137.855,0,168.96v198.81
                    c0,31.105,25.215,56.32,56.32,56.32h358.4c31.105,0,56.32-25.215,56.32-56.32V168.96C471.04,137.855,445.825,112.64,414.72,112.64
                    z M235.52,378.01c-70.042,0-126.822-56.78-126.822-126.822c0-70.042,56.78-126.822,126.822-126.822s126.822,56.78,126.822,126.822
                    C362.258,321.194,305.527,377.925,235.52,378.01z M407.605,191.949c-0.615,0.034-1.231,0.034-1.846,0v0h-20.48
                    c-9.176-0.51-16.201-8.361-15.692-17.537c0.47-8.464,7.228-15.222,15.692-15.692h20.48c9.176-0.51,17.028,6.516,17.537,15.692
                    C423.807,183.588,416.781,191.439,407.605,191.949z"/>
            </g>
        </g>
        <g>
            <g>
                <path fill="currentColor" d="M235.52,180.582c-38.994,0-70.605,31.611-70.605,70.605s31.611,70.605,70.605,70.605s70.605-31.611,70.605-70.605
                    C306.097,212.205,274.502,180.611,235.52,180.582z"/>
            </g>
        </g>
    </svg>
</template>